import React, { Component, Fragment } from 'react';

import classnames from 'classnames';

import ColorPicker from 'components/ColorPicker';
import StylesRadioImage from 'components/StylesRadioImage';

import bgImgStyle1 from 'images/bg-img-style1.svg';

class TextColorStyles extends Component {
  acceptTextColor = (id, value, type, typeValue) => {
    const { acceptTextColor } = this.props;
    let body = {};
    body[id] = value;
    body[type] = typeValue;
    acceptTextColor(body);
  };

  render() {
    const { defaultTextColorValues } = this.props;
    return (
      <Fragment>
        <h2 className="h2-title">Text color</h2>
        <div className="separator-line m-b-40" />
        <div className="style-form m-b-50">
          <div className="style-form__row">
            <div className="style-form__col bg flex">
              <div className="style-form__subtitle top">Page text</div>
              <div className="bg-images-group">
                <div className="bg-image-itm">
                  <label
                    className={classnames('bg-image-itm__label', {
                      'bg-image-itm__label__checked':
                        defaultTextColorValues.page_text_type === 'color',
                    })}>
                    <ColorPicker
                      color={defaultTextColorValues.page_text_value}
                      acceptColor={color =>
                        this.acceptTextColor(
                          'page_text_value',
                          color,
                          'page_text_type',
                          'color',
                        )
                      }
                    />
                  </label>
                </div>
              </div>
            </div>
            <div className="style-form__col bg flex">
              <div className="style-form__subtitle top">Hover text</div>
              <div className="bg-images-group">
                <StylesRadioImage
                  src={bgImgStyle1}
                  htmlFor="background-overlay-style"
                  labelClassName={classnames('bg-image-itm__label', {
                    'bg-image-itm__label__checked':
                      defaultTextColorValues.hover_text_type === null,
                  })}
                  radioName="background-overlay-style"
                  radioClassName="bg-image-itm__input invisible"
                  alt="image99"
                  onChange={() =>
                    this.acceptTextColor(
                      'hover_text_value',
                      null,
                      'hover_text_type',
                      null,
                    )
                  }
                  checked={defaultTextColorValues.hover_text_value === null}
                />
                <div className="bg-image-itm">
                  <label
                    className={classnames('bg-image-itm__label', {
                      'bg-image-itm__label__checked':
                        defaultTextColorValues.hover_text_type === 'color',
                    })}>
                    <ColorPicker
                      color={defaultTextColorValues.hover_text_value}
                      acceptColor={color =>
                        this.acceptTextColor(
                          'hover_text_value',
                          color,
                          'hover_text_type',
                          'color',
                        )
                      }
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default TextColorStyles;



// WEBPACK FOOTER //
// ./src/scenes/Styles/TextColorStyles.js